var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { ActivatedRoute, Router } from "@angular/router";
import { TranslateService } from "app/translate/translate.service";
import { FilterFormService } from "app/views/filter_form/filter_form.service";
import { EventsService } from "app/lib/EventsService";
import { BaseComponent } from "app/views/base.component";
import { ChartParams } from "../../views/chart/chart.component";
import * as qs from 'qs';
import { BillingService2 } from "../billing.service";
var ConversionRateComponent = /** @class */ (function (_super) {
    __extends(ConversionRateComponent, _super);
    function ConversionRateComponent(route, translate, filter, eventsService, router, service2) {
        var _this = _super.call(this, eventsService, service2, route, filter, translate) || this;
        _this.route = route;
        _this.translate = translate;
        _this.filter = filter;
        _this.eventsService = eventsService;
        _this.router = router;
        _this.service2 = service2;
        _this.chartPeriod = '30days';
        _this.langTab = 'ru';
        _this.reportUrl = _this.router.url.split('?')[0];
        _this.listLoader = false;
        _this.firstChart = new ChartParams();
        _this.secondChart = new ChartParams();
        _this.showLabels = {
            firstChart: ['tariffVisitCount', 'paymentVisitCount', 'paidCount'],
            secondChart: ['tariffAndPaymentConversion', 'paidAndPaymentConversion']
        };
        _this.totalPages = 0;
        _this.currentPage = 1;
        _this.pages = [];
        _this.links = [];
        _this.paginationLoader = true;
        _this.route.queryParams.subscribe(function (params) {
            _this.langTab = params.langTab || 'ru';
        });
        _this.firstChart.setOptions({
            title: '',
            names: {
                'paidCount': _this.translate.__A('adminstat.yandex.paidCount'),
                'tariffVisitCount': _this.translate.__A('adminstat.yandex.tariffVisitCount'),
                'paymentVisitCount': _this.translate.__A('adminstat.yandex.paymentVisitCount')
            },
            colors: {
                'tariffVisitCount': '#ff7f0e',
                'paymentVisitCount': '#2ca02c',
                'paidCount': '#d62728'
            },
            showLabels: _this.showLabels.firstChart
        });
        _this.secondChart.setOptions({
            title: '',
            names: {
                'tariffAndPaymentConversion': _this.translate.__A('adminstat.yandex.tariffAndPaymentConversion'),
                'paidAndPaymentConversion': _this.translate.__A('adminstat.yandex.paidAndPaymentConversion')
            },
            colors: {
                'tariffAndPaymentConversion': '#ff7f0e',
                'paidAndPaymentConversion': '#2ca02c'
            },
            showLabels: _this.showLabels.secondChart
        });
        return _this;
    }
    Object.defineProperty(ConversionRateComponent.prototype, "localFilter", {
        get: function () {
            return {
                langTab: this.langTab,
                page: this.filter.filterParams.page,
                chartPeriod: this.filter.filterParams.period == 'day' ? this.chartPeriod : 'all',
                period: this.filter.filterParams.period,
                chartFormat: 'c3angular'
            };
        },
        enumerable: true,
        configurable: true
    });
    ConversionRateComponent.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.getPagination()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.getStats()];
                    case 3:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionRateComponent.prototype.getChart = function () {
        return __awaiter(this, void 0, void 0, function () {
            var charts, fdata, sdata, _i, charts_1, row, id;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.firstChart.showLoader();
                        return [4 /*yield*/, this.service2.conversionRate.chart(this.localFilter).toPromise()];
                    case 1:
                        charts = (_a.sent()).charts;
                        fdata = [];
                        sdata = [];
                        for (_i = 0, charts_1 = charts; _i < charts_1.length; _i++) {
                            row = charts_1[_i];
                            id = row[0];
                            if (id == 'x') {
                                fdata.push(row);
                                sdata.push(row);
                            }
                            else {
                                if (this.showLabels.firstChart.includes(id.toString())) {
                                    fdata.push(row);
                                }
                                if (this.showLabels.secondChart.includes(id.toString())) {
                                    sdata.push(row);
                                }
                            }
                        }
                        this.firstChart.data = fdata;
                        this.secondChart.data = sdata;
                        this.firstChart.hideLoader();
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionRateComponent.prototype.updateData = function (filter, type) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    // Получить данные для пагинации
    ConversionRateComponent.prototype.getPagination = function () {
        return __awaiter(this, void 0, void 0, function () {
            var me, pagination;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        me = this;
                        me.totalPages = 1;
                        me.currentPage = 1;
                        me.pages = [];
                        me.paginationLoader = true;
                        return [4 /*yield*/, me.service2.conversionRate.pagination(me.localFilter).toPromise()];
                    case 1:
                        pagination = _a.sent();
                        me.pagination.fill(pagination);
                        if (pagination) {
                            me.updateLinks(me.service2.conversionRate.getRealFullRoute());
                        }
                        me.paginationLoader = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionRateComponent.prototype.getStats = function () {
        return __awaiter(this, void 0, void 0, function () {
            var stats;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.service2.conversionRate.stats(__assign({}, this.localFilter, { paginationDate: this.pages[this.filter.filterParams.page - 1] })).toPromise()];
                    case 1:
                        stats = (_a.sent()).stats;
                        this.stats = stats;
                        return [2 /*return*/];
                }
            });
        });
    };
    ConversionRateComponent.prototype.onPageChange = function () {
        return __awaiter(this, void 0, void 0, function () {
            var params, url;
            return __generator(this, function (_a) {
                this.filter.filterParams.page = this.pagination.page;
                this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);
                params = this.filter.getApplyFilters(this.filter.filterParams), url = this.router.url.split('?')[0];
                params = qs.stringify(params, { encode: false });
                this.router.navigateByUrl(url + "?" + params, { relativeTo: this.activatedRoute });
                return [2 /*return*/];
            });
        });
    };
    ConversionRateComponent.prototype.onFilterChange = function (chartPeriod) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.chartPeriod = chartPeriod;
                        return [4 /*yield*/, this.getChart()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return ConversionRateComponent;
}(BaseComponent));
export { ConversionRateComponent };
